import {twx} from '@/utils/tailwindUtils';

type ButtonRawProps = React.ComponentProps<'button'>;

const ButtonRaw = ({type = 'button', className, ref, ...restProps}: ButtonRawProps) => (
    <button ref={ref} type={type} className={twx(className)} {...restProps} />
);

ButtonRaw.displayName = 'ButtonRaw';

export default ButtonRaw;
